import type {
  CancelProspectEmails200,
  CancelProspectEmailsBody,
  GmailConnection,
  ProspectCounts,
  ProspectDetail,
  ProspectQueue,
  ProspectStage,
  ProspectStatus,
  ProspectSummaryList,
  SendProspectEmails200,
  SendProspectEmailsBodyEmailsItem,
  UpdateProspectBody
} from '@api/models';

import { BrowserApiClient } from '@website/lib/api/browser';

export interface ProspectFilters {
  stage?: ProspectStage;
  q?: string;
  ids?: string[];
}

/** What the tab counts follow: the search and a link's prospects, not the tab itself. */
export type ProspectScope = Pick<ProspectFilters, 'q' | 'ids'>;

export const listProspects = async (filters: ProspectFilters, cursor?: string): Promise<ProspectSummaryList> =>
  BrowserApiClient.listProspects({ ...filters, ...(cursor ? { cursor } : {}) });

export const getProspect = async (id: string): Promise<ProspectDetail> => BrowserApiClient.getProspect(id);

export const updateProspect = async (id: string, fields: UpdateProspectBody) =>
  BrowserApiClient.updateProspect(id, fields);

export const setProspectDraft = async (id: string, draft: { subject: string; body: string }) =>
  BrowserApiClient.setProspectDraft(id, draft);

export const setProspectStatus = async (id: string, status: ProspectStatus) =>
  BrowserApiClient.setProspectStatus(id, { status });

export const sendProspectEmails = async (emails: SendProspectEmailsBodyEmailsItem[]): Promise<SendProspectEmails200> =>
  BrowserApiClient.sendProspectEmails({ emails });

export const getGmailConnection = async (): Promise<GmailConnection> => BrowserApiClient.getGmailConnection();

export const createGmailConnectUrl = async (): Promise<{ url: string }> => BrowserApiClient.createGmailConnectUrl({});

export const getProspectCounts = async (scope: ProspectScope): Promise<ProspectCounts> =>
  BrowserApiClient.getProspectCounts(scope);

export const getProspectQueue = async (): Promise<ProspectQueue> => BrowserApiClient.getProspectQueue();

export const cancelProspectEmails = async (target: CancelProspectEmailsBody): Promise<CancelProspectEmails200> =>
  BrowserApiClient.cancelProspectEmails(target);
